module.exports = __webpack_public_path__ + "img/icons B_10.431ec1df.png";